export enum EmailTemplateModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
